import './home.me.screen.scss';
import {Box, Typography, useTheme} from '@mui/material';
import {ContentPage} from '../../../../../components/content-page/content-page';
import {translations} from '../../../../../i18n/translations';
import {useTranslation} from 'react-i18next';
import {useContext} from 'react';
import {AppContext} from '../../../../../contexts/app/context';
import {AppContextType} from '../../../../../contexts/app/types';
import {getBrandName} from '../../../../../utils/functions/get-product-name';
import FeedbackIcon from '@mui/icons-material/Feedback';

export default function HomeMeOfficeScreen() {
  // Get context
  const appContext: AppContextType = useContext(AppContext);

  // Get theme
  const theme = useTheme();

  // Translations
  const {t} = useTranslation();

  return (
    <ContentPage>
      <Box className="home-screen-message-container">
        <FeedbackIcon sx={{color: theme.palette.grey[600]}} className="home-screen-message-icon" />
        <Typography variant="h6" component="p" className="home-screen-message-title">
          {t(translations.home.none.root.no_associations_message_title, {
            brand: getBrandName(appContext.state.configuration.product),
          })}
        </Typography>
        <Typography variant="body1" component="p" className="home-screen-message-subtitle">
          {t(translations.home.none.root.no_associations_message_subtitle)}
        </Typography>
      </Box>
    </ContentPage>
  );
}
